export default "__VITE_ASSET__CMNRz9uI__"